import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Phone from '@material-ui/icons/Phone';
import UserInfo from 'components/BookingInfo/UserInfo';
import isEmpty from 'lodash/isEmpty';

const ShowMoreButton = ({ data, isFetching, currentUser }) => {
  const [isShowMore, setIsShowMore] = React.useState(false);

  if (isFetching || isEmpty(data) || isEmpty(currentUser)) {
    return null;
  }

  const showMoreClick = () => {
    setIsShowMore(!isShowMore);
  };

  const otherUsers = data.Users.filter(
    (user) => user.id !== currentUser.id && (user.phone_1 || user.phone_2),
  );

  if (!otherUsers.length) {
    return null;
  }

  return (
    <>
      <IconButton aria-label="Show profile" onClick={showMoreClick}>
        <Phone />
      </IconButton>

      <Dialog open={isShowMore} onClose={showMoreClick} maxWidth="sm" fullWidth>
        <div>
          <Box p={2}>
            <Box>
              {otherUsers.map((user) => (
                <UserInfo key={user.id} isNameHeader {...user} />
              ))}
            </Box>
            <Box textAlign="right" mt={2}>
              <Button size="small" color="primary" onClick={showMoreClick}>
                <FormattedMessage id="Close" defaultMessage="Close" />
              </Button>
            </Box>
          </Box>
        </div>
      </Dialog>
    </>
  );
};

ShowMoreButton.propTypes = {
  data: PropTypes.shape({
    Users: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }),
  isFetching: PropTypes.bool,
  currentUser: PropTypes.shape({
    id: PropTypes.number,
  }),
};

export default ShowMoreButton;
